import { useMemo } from 'react';

import { APP_CONFIG_AEXP } from '@hcs/app-configs';
import { useCapabilityCheck } from '@hcs/authz';
import { AppConfig } from '@hcs/types';

/**
 * Returns the AEXP app config with dynamic nomenclature based on user type.
 * Self-serve users (with platform-search-experience capability) see "Saved Searches".
 * Enterprise users see "Acquisition Explorer".
 */
export const useAexpAppConfig = (): AppConfig => {
  const { data: hasPlatformSearchAccess } = useCapabilityCheck(
    'platform-search-experience',
  );

  return useMemo(() => {
    const isSelfServe = !!hasPlatformSearchAccess;

    if (isSelfServe) {
      return {
        ...APP_CONFIG_AEXP,
        name: 'Saved Searches',
        descriptionShort:
          'Create saved searches to identify target properties across any market of your choice.',
      };
    }

    return APP_CONFIG_AEXP;
  }, [hasPlatformSearchAccess]);
};
